import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar/Navbar";
import MobileBottomNav from "./components/MobileBottomNav/MobileBottomNav";
import HomeScreen from "./screen/HomeScreen";
import ErrorScreen from "./screen/ErrorScreen";
import SaaSLandingPage from "./screen/SaaSLandingPage";
import PrivacyPolicy from "./screen/PrivacyPolicy";
import TermsOfService from "./screen/TermsOfService";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import Cart from "./screen/Cart";
import MenuCardScreen from "./screen/MenuCardScreen";
import Connect from "./screen/Connect";
import ReelsScreen from "./screen/ReelsScreen";
import ProductDetailsScreen from "./screen/ProductDetailsScreen";
import { setupCartCleanup } from "./utils/cartCleanup";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfile } from "./redux/menu/ProfileSlice";
import CustomThemeProvider from "./components/ThemeProvider/ThemeProvider";

const theme = createTheme({
  typography: {
    fontFamily: "'Roboto', sans-serif",
  },
  shape: {
    borderRadius: 12,
  },
});
function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { profile, status } = useSelector((state) => state.profile);

  // Set up cart cleanup on app start
  useEffect(() => {
    setupCartCleanup();
  }, []);

  // Fetch profile only once on initial load if not on landing page
  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    // const isLandingPage = location.pathname === "/";

    // Only fetch if not on landing page, have store ID, and profile not already loaded
    if (
      // !isLandingPage &&
      // pathParts.length > 0 &&
      // status === "idle" &&
      !profile
    ) {
      dispatch(fetchProfile())
        .unwrap()
        .then((data) => {
          if (data?.DocLogo?.imageUrl) {
            const link =
              document.querySelector("link[rel*='icon']") ||
              document.createElement("link");
            link.type = data?.DocLogo?.content_type || "image/x-icon";
            link.rel = "icon";
            link.href = data?.DocLogo?.imageUrl;
            document.head.appendChild(link);
            document.title = `${data.name} | Yorokart By YORO`;
          }
        })
        .catch((err) => {
          console.error("Profile failed:", err);
          navigate("/page/notFound");
        });
    }
  }, [dispatch, navigate, profile, status]);

  // Check if we're on the landing page
  const isLandingPage = false;

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CustomThemeProvider>
          <CssBaseline />

          {!isLandingPage && <Navbar />}
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/:id" element={<HomeScreen />} />
            <Route path="/:id/orders" element={<Cart />} />
            <Route
              path="/:id/product/:productId"
              element={<ProductDetailsScreen />}
            />
            <Route path="/:id/table-top-menu" element={<MenuCardScreen />} />
            <Route path="/:id/connect" element={<Connect />} />
            <Route path="/:id/reels" element={<ReelsScreen />} />
            <Route path="*" element={<ErrorScreen />} />
          </Routes>
          {!isLandingPage && <MobileBottomNav />}
        </CustomThemeProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
